export const CELL_LAYOUT_TEMPLATES = [
  // Classic grids
  { key: "grid_3x3", label: "3 × 3 Grid", grid: { rows: 3, columns: 3 } },
  { key: "grid_2x2", label: "2 × 2 Grid", grid: { rows: 2, columns: 2 } },
  { key: "grid_2x3", label: "2 × 3 Grid", grid: { rows: 2, columns: 3 } },
  { key: "grid_3x2", label: "3 × 2 Grid", grid: { rows: 3, columns: 2 } },
  { key: "grid_4x3", label: "4 × 3 Grid", grid: { rows: 4, columns: 3 } },
  { key: "grid_4x4", label: "4 × 4 Grid", grid: { rows: 4, columns: 4 } },
  // Horizontal strips (stacked rows)
  { key: "grid_2x1", label: "2 × 1 Horizontal", grid: { rows: 2, columns: 1 } },
  { key: "grid_3x1", label: "3 × 1 Horizontal", grid: { rows: 3, columns: 1 } },
  { key: "grid_4x1", label: "4 × 1 Horizontal", grid: { rows: 4, columns: 1 } },
  // Vertical strips (side-by-side columns)
  { key: "grid_1x2", label: "1 × 2 Vertical", grid: { rows: 1, columns: 2 } },
  { key: "grid_1x3", label: "1 × 3 Vertical", grid: { rows: 1, columns: 3 } },
  { key: "grid_1x4", label: "1 × 4 Vertical", grid: { rows: 1, columns: 4 } },
  // Splash / single
  { key: "grid_1x1", label: "Splash (Full Page)", grid: { rows: 1, columns: 1 } },
  // Manga asymmetric
  { key: "grid_3x4", label: "3 × 4 Manga", grid: { rows: 3, columns: 4 } },
  { key: "grid_5x3", label: "5 × 3 Dense", grid: { rows: 5, columns: 3 } },
  { key: "grid_2x4", label: "2 × 4 Wide", grid: { rows: 2, columns: 4 } },
];

export const defaultCellLayoutTemplate = CELL_LAYOUT_TEMPLATES[0];

export const findCellLayoutTemplate = (key) =>
  CELL_LAYOUT_TEMPLATES.find((template) => template.key === key) || null;

export const matchCellLayoutTemplateByGrid = (rows, columns) =>
  CELL_LAYOUT_TEMPLATES.find(
    (template) =>
      template.grid.rows === rows && template.grid.columns === columns
  ) || null;
